export default {"src":"/_next/static/media/quality-meats-badge.856c60e9.svg","height":384,"width":384};